export default __webpack_public_path__ + "static/lotusBG-8f5ffb5ce1bf21a7d1950ab6f7f6d8d9.svg";